import { tv } from 'tailwind-variants';

interface ContentContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  children: React.ReactNode;
}

const contentStyle = tv({
  slots: {
    content: ['w-full px-6 sm:px-16 md:px-0 md:mx-auto md:max-w-xl xl:max-w-5xl 3xl:max-w-7xl'],
  },
});

export function ContentContainer({ className, children, ...rest }: ContentContainerProps) {
  const { content } = contentStyle();
  return (
    <div className={content({ className })} {...rest}>
      {children}
    </div>
  );
}
